import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const BoxAnimation = () => {
  const containerRef = useRef(null);
  const imageRef = useRef(null);
  const glowRef = useRef(null);

  useEffect(() => {
    if (!imageRef.current || !containerRef.current) return;

    // Main timeline for entrance and continuous animation
    const tl = gsap.timeline({ delay: 0.3 });

    // Entrance animation - image scales in with elegant motion
    tl.fromTo(imageRef.current, 
      {
        scale: 0.85,
        opacity: 0,
        y: 40,
        rotationY: -15
      },
      {
        scale: 1,
        opacity: 1,
        y: 0,
        rotationY: 0,
        duration: 1.4,
        ease: 'power3.out'
      }
    )
    // Continuous breathing animation
    .to(imageRef.current, {
      y: -12,
      scale: 1.02,
      duration: 2.5,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut'
    })
    // Subtle rotation
    .to(imageRef.current, {
      rotationY: 3,
      duration: 4,
      repeat: -1,
      yoyo: true,
      ease: 'sine.inOut'
    }, '<');

    // Glow pulse animation
    if (glowRef.current) {
      gsap.to(glowRef.current, {
        opacity: 0.6,
        scale: 1.1,
        duration: 2,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });
    }

    // Scroll-triggered parallax
    gsap.to(imageRef.current, {
      scrollTrigger: {
        trigger: containerRef.current,
        start: 'top top',
        end: 'bottom top',
        scrub: 1,
      },
      y: 40,
      rotationY: 8,
      ease: 'none'
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      tl.kill();
    };
  }, []);

  return (
    <div ref={containerRef} className="packaging-animation-container">
      <div className="packaging-scene">
        {/* Animated glow background */}
        <div ref={glowRef} className="packaging-glow"></div>
        
        {/* Main product image with animations */}
        <div ref={imageRef} className="packaging-image-wrapper">
          <img 
            src="https://customer-assets.emergentagent.com/job_sagarpack-studio/artifacts/r1mevllr_Gemini_Generated_Image_25170n25170n2517-removebg-preview.png"
            alt="Sagar Pack Premium Packaging Solutions"
            className="packaging-image"
          />
          
          {/* Shine overlay effect */}
          <div className="packaging-shine"></div>
        </div>
      </div>
    </div>
  );
};

export default BoxAnimation;
